import React from 'react'
import {Header, List} from 'semantic-ui-react'

const InspectRequest = () => {
  return (
    <div className='doc-section'>
      <Header as='h2'>Inspect Request</Header>
      <Header as='h3' dividing>Steps:</Header>
      <List relaxed>
        <List.Item>1. Call a service mock </List.Item>
        <List.Item>2. Log into Service Mocks</List.Item>
        <List.Item>3. Find and select the service you just called</List.Item>
        <List.Item>4. Make sure the version and environment used in the request are selected and expanded</List.Item>
        <List.Item>5. Expand the resource you called</List.Item>
        <List.Item>6. Click on the "Logs" tab</List.Item>
        <List.Item>7. Optionally provide query text or response status/name filter selection to narrow the
          results</List.Item>
        <List.Item>8. Expand the log w/ the timestamp nearest to the time you sent the request</List.Item>
        <List.Item>9. Review the request received and the response that was returned</List.Item>
      </List>
    </div>
  )
}

export {InspectRequest}

export default InspectRequest